import { autoinject } from "aurelia-framework";
import { AiService } from "../../services/axxess-intelligence-service";

@autoinject
export class AiUsageStore {
    public _AiService: AiService;
    public isAiPremiumUser = false;
    public isWithinUsageLimit = false;

    public constructor(_aiService: AiService) {
        this._AiService = _aiService;
    }

    public async initialize(accountId: string): Promise<void> {
        try {
            let response = await this._AiService.isPremiumAiUser(accountId);
            if (response.status === 200) {
                this.isAiPremiumUser = response.isAxxessIntelligenceEnabled;
            }
            if (!this.isAiPremiumUser) {
                let response2 = await this._AiService.isAxxessFeatureLocked();
                if (response2.status === 200) {
                    this.isWithinUsageLimit = response2.isWithinLimits;
                }
            }
        } catch (err) {
            console.error(err);
        }
    }
}
